const boeTaskEn = {
  components: {
    operationTaskActionButton: {
      defaultActionButtonText: "Execute",
    },
    stepContainer: {
      description: "Description",
    },
    peopleGroupEditDialog: {
      titleReadOnly: "Group Information",
      titleEdit: "Edit Group",
      descriptionReadOnly:
        "Displaying group information for the approval flow.",
      descriptionEdit:
        "You can edit the group information for the approval flow.",
      groupLabel: "Group *",
      groupUnset: "Group is not set",
      groupSelectPlaceholder: "Select a group",
      groupRequired: "Please select a group",
      buttonClose: "Close",
      buttonCancel: "Cancel",
      buttonSave: "Save",
    },
    personEditDialog: {
      titleReadOnly: "Person Information",
      titleEdit: "Edit Person",
      descriptionReadOnly:
        "Displaying person information for the approval flow.",
      descriptionEdit:
        "You can edit the person information for the approval flow.",
      personLabel: "Person *",
      personRequired: "Please select a person",
      buttonClose: "Close",
      buttonCancel: "Cancel",
      buttonSave: "Save",
    },
    approvalTaskConfig: {
      validationErrorAllStages:
        "Please set a People Group for all approval stages",
      saveSuccess: "Configuration saved successfully",
      saveFailed: "Failed to save configuration",
      buttonSave: "Save",
    },
    taskConfigItems: {
      notInUseTitle: "Not in use",
      tooltipRemove: "Do not use this task",
      buttonEdit: "Edit",
      buttonAdd: "Add",
      buttonView: "View",
      enable: {
        error: {
          title: "Failed to enable",
          missingInfo: "Task information is missing",
        },
        success: {
          title: "Enabled successfully",
          description: "Item has been enabled",
        },
      },
      disable: {
        error: {
          title: "Failed to disable",
          operationFailed: "Operation failed",
          systemRequired: "System required items cannot be disabled",
          lastItem: "Cannot disable the last item",
          missingInfo: "Task information is missing",
        },
        success: {
          title: "Disabled successfully",
          description: "{{name}} has been disabled",
        },
      },
      tooltip: {
        systemRequired: "System required items cannot be disabled",
      },
    },
    approvalStageRule: {
      fieldTitle: "Number of Approval Stages",
      stageLabel: "{{count}} stage",
    },
    todoTaskConfig: {
      notSet: "TODO is not set.",
      pleaseSetTodo: "Please set TODO.",
      editButton: "Edit",
    },
    todoChecklistEditDialog: {
      title: "Edit TODO",
      description: "Please edit the TODO.",
      displayNameLabel: "Display Name",
      displayNamePlaceholder: "Enter display name",
      displayNameRequired: "Please enter TODO display name",
      displayNameMaxLength: "Display name must be within 100 characters",
      descriptionLabel: "Description",
      descriptionPlaceholder: "Enter description",
      descriptionMaxLength: "Description must be within 500 characters",
      checklistLabel: "Checklist",
      addItemButton: "Add Item",
      noItemsMessage:
        'No checklist items. Please add items using the "Add Item" button.',
      itemPlaceholder: "Enter checklist item",
    },
    labelTask: {
      helpTooltipLabel: "Task generation information",
    },
  },
};

export default boeTaskEn;
